import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteBroadCategory, getAllBroadCategories,createBroadCategory,editBroadCategory,getOneBroadCategory } from '../../api/axiosBroadCategories';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';









const BroadCategories = () => {
  const { broadCategories, setBroadCategories, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [broadCategory, setBroadCategory] = useState("");
  const [editedBroadCategory, setEditedBroadCategory] = useState("");
  


 

  const NewTitle = "All BroadCategories";
  useEffect(() => {
    
    getAllBroadCategories(setBroadCategories, setFetcherror);
    
  }, []);


  const filteredBroadCategories = broadCategories.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()))
  const filteredReversedBroadCategories = filteredBroadCategories.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setBroadCategories, setFetcherror, handleAllToasts) => {
    return () => {
      deleteBroadCategory(pkid, setBroadCategories, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this BroadCategory?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedBroadCategory(foundItem?.name);
   
   }

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
      <SearchToolBar
          setAddItemDialogVisible={setAddItemDialogVisible}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          searchPlaceholder="BroadCategories"
          createLabel="BroadCategory"
  />

        
        <DataTable
          value={filteredBroadCategories}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No broadCategories found"
        >
                    <Column header="S/N" body={(rowData) => broadCategories.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Name"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                          <TableActions
                          id={rowData.id}
                          data={broadCategories}
                          getItemtoEdit={getItemtoEdit}
                          setSelectedId={setSelectedId}
                          setEditDialogVisible={setEditDialogVisible}
                          setDeleteDialogVisible={ setDeleteDialogVisible}
                        />
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New BroadCategory" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createBroadCategory(broadCategory, setBroadCategory, setFetcherror, handleAllToasts, setBroadCategories);
                if (broadCategory) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter BroadCategory Name"
                    value={broadCategory}
                    onChange={(e) => setBroadCategory(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setBroadCategory("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit BroadCategory" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editBroadCategory( selectedId, editedBroadCategory, setEditedBroadCategory,  setFetcherror, handleAllToasts, setBroadCategories);
                if (editedBroadCategory) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter BroadCategory Name"
                    value={editedBroadCategory}
                    onChange={(e) => setEditedBroadCategory(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setBroadCategory("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setBroadCategories, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default BroadCategories


